.logo {
  display: block;
  flex-shrink: 0;
}
